module.exports = {
        srcSet: __webpack_public_path__ + "amenities_amazon_locker_MO-120-26e4bc1210fd255b.digested.png"+" 120w",
        images: [{path: __webpack_public_path__ + "amenities_amazon_locker_MO-120-26e4bc1210fd255b.digested.png",width: 120,height: 119}],
        src: __webpack_public_path__ + "amenities_amazon_locker_MO-120-26e4bc1210fd255b.digested.png",
        toString: function(){return __webpack_public_path__ + "amenities_amazon_locker_MO-120-26e4bc1210fd255b.digested.png"},
        
        width: 120,
        height: 119
      }